import React, { useEffect, useState } from "react";
import CreateBtn from "../../../components/buttons/createBtn";
import searcher from "../../../assets/icons/searchInput.svg";
import MainLayout from "../../../components/layout/mainLayout/mainLayout";
import ReasonRejectionListTable from "./reasonRejectionListTable";
import { useNavigate, useLocation } from "react-router-dom";

const ReasonRejectionList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_admin") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Settings" && item
      );

      setUserData(permissionValue);
    }
  }, [user_type]);

  return (
    <MainLayout breadCrumb="ADMIN  /  settings  /  Reasons for rejection">
      <div>
        <div className="search-container d-flex justify-content-between">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} alt="o" />
            <input
              value={search}
              className="search-input fs_14 fw_400 px-2 text-dark"
              type="text"
              placeholder="Search here by Reason For Rejection..."
              onChange={(e) => {
                navigate(
                  `/settings/reason-for-rejection?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                );
              }}
            />
          </div>

          <div className="d-flex justify-content-between m-1 mb-2">
            {(user_type === "super_admin" && userData?.write) ||
            user_type === "admin" ? (
              <CreateBtn link="/settings/reason-for-rejection/create" />
            ) : (
              ""
            )}
          </div>
        </div>
        <ReasonRejectionListTable search={search} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default ReasonRejectionList;
